export const CAPTCHA_TYPE_YANDEX = 'yandex';
export const CAPTCHA_TYPE_GOOGLE = 'google';

export const YANDEX_CAPTCHA_LANGS = {
  ru: 'ru',
  en: 'en',
  uz: 'uz',
  ua: 'uk',
  be: 'be',
  kz: 'kk',
  tr: 'tr'
};
